import request from '@/utils/request';
export default {

        getDataNumber(dataName) {
            
            return request({
                url: '/'+dataName+'/num',
                method: 'get',
            });
        },
}